export const BQ_PROJECT_NAME = process.env.REACT_APP_BQ_PROJECT;
export const BQ_CONNECTION_NAME = process.env.REACT_APP_CARTO_CONNECTION_BQ;
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
export const ORGANIZATION_ID = process.env.REACT_APP_ORGANIZATION_ID;
